'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _typeof2 = require('babel-runtime/helpers/typeof');

var _typeof3 = _interopRequireDefault(_typeof2);

var _isUndefined2 = require('lodash/isUndefined');

var _isUndefined3 = _interopRequireDefault(_isUndefined2);

var _map2 = require('lodash/map');

var _map3 = _interopRequireDefault(_map2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _ = { map: _map3.default, isUndefined: _isUndefined3.default };

function chatController(livePresenceService, $attrs, $rootScope, $scope, $window, $timeout) {
    //const
    var vm = this;
    var userClass = 'chat__bubble chat__bubble--customer chat__bubble--show';
    var agentClass = 'chat__bubble chat__bubble--bot chat__bubble--show';
    var liveClass = 'chat__bubble chat__bubble--live chat__bubble--show';
    var loader = '<div class="loader">\n                        <div class="worm worm--mais worm__p1"></div>\n                        <div class="worm worm--mais worm__p2"></div>\n                        <div class="worm worm--mais worm__p3"></div>\n                        <div class="worm worm--mais worm__p4"></div>\n                    </div>';

    vm.isActive = false;
    vm.attr = $attrs;
    vm.searchString = '';
    vm.enabled = false;
    vm.isLive = false;
    vm.agentName = '';
    vm.isKassabonVisible = false;
    vm.isKassabonPresent = false;

    //assign functions
    vm.start = start;
    vm.toggleActive = toggleActive;
    vm.setAgentName = setAgentName;
    vm.displayLoading = displayLoading;

    //initialize LivePresence service
    init();

    //functions
    function init() {
        var env = vm.attr.env || 'prd';
        var config = vm.attr.config || 'homepage';

        livePresenceService.init(config, env);
    }

    function toggleActive(state) {
        if (_.isUndefined(state)) {
            vm.isActive = !vm.isActive;
        } else {
            vm.isActive = state;
        }

        document.cookie = 'vaChat=' + vm.isActive + '; path=/';
    }

    function setFlow($event, searchString, flow) {
        var data = {},
            flowLP = flow !== null ? flow : vm.attr.flow;

        if ($event !== undefined) {
            buttonState($event.currentTarget);
        }

        if ($window.Application && flowLP) {
            $window.Application.HandleMouseClick(flowLP);
        }

        vm.searchString = searchString || vm.searchString;

        data.event = 'mouse';
        data.element = null;
        data.searchstring = vm.searchString;

        $rootScope.$broadcast('open-livechat', data);

        return true;
    }

    function start($event, searchString, flow) {
        toggleActive(true);
        setFlow($event, searchString, flow);
    }

    function buttonState(element) {
        var element = angular.element(element),
            parent = element.parent(),
            btns = parent.find('.chat__btn');

        element.addClass('is-active');

        _.map(btns, function (btn) {
            var btnElement = angular.element(btn);
            btnElement.attr('disabled', true);
        });
    }

    function getCookie(cname) {
        var name = cname + '=';
        var decodedCookie = decodeURIComponent(document.cookie);
        var ca = decodedCookie.split(';');

        for (var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) === ' ') {
                c = c.substring(1);
            }
            if (c.indexOf(name) === 0) {
                return c.substring(name.length, c.length);
            }
        }
        return null;
    }

    function setAgentName(name, fullname) {
        if ((typeof name === 'undefined' ? 'undefined' : (0, _typeof3.default)(name)) === undefined || name === null || name === '' || name === 'Centraal Beheer') {
            vm.agentName = '';
            vm.isLive = false;
            gWebClient.mConversation.mAgentElementClass = agentClass;
        } else {
            vm.agentName = name;
            vm.isLive = true;
            gWebClient.mConversation.mAgentElementClass = liveClass;
        }
    }

    function displayLoading() {
        var element = document.getElementById('iChatLines');
        element.insertAdjacentHTML('beforeend', loader);
    }

    //timer
    //Sometimes Live Presence does not load correctly.
    //To prevent irritation with the user who would be unable to report damage, the page now refreshes after 5 seconds if LP doesn't load
    var t = $timeout(function () {
        if (sessionStorage.getItem('lp-reloaded') !== 'true') {

            sessionStorage.setItem('lp-reloaded', 'true');
            $window.location.reload();
        }
    }, 5000);

    //events
    $scope.$on('livechat-ready', function () {
        $timeout.cancel(t);
        vm.enabled = true;

        if (typeof gWebClient !== 'undefined' && gWebClient !== null && gWebClient.HasStarted) {
            gWebClient.mConversation.mUserElementClass = userClass;
            gWebClient.mConversation.mUserName = '';
            gWebClient.mConversation.mAgentElementClass = agentClass;
        }

        if (getCookie('vaChat') !== null && getCookie('vaChat') === 'true') {
            toggleActive(true);

            var chatAnswers = document.getElementsByClassName('chat__answers');

            if (chatAnswers.length > 0) {
                chatAnswers[0].remove();
            }
        }
    });
}

chatController.$inject = ['livePresenceService', '$attrs', '$rootScope', '$scope', '$window', '$timeout'];

exports.default = chatController;


//////////////////
// WEBPACK FOOTER
// ./src/lib/ui-components/chat/chat.controller.js
// module id = 871
// module chunks = 0